import React from "react";
import { useNavigate } from "react-router-dom";
import { DoorClosed, MapPin, Lock, ArrowLeft } from "lucide-react";
import { EMERGENCY } from "@/constants/testIds";
import DisclaimerBanner from "@/components/DisclaimerBanner";

const SCENARIOS = [
  {
    id: "door",
    title: "ICE en mi puerta",
    desc: "Están tocando o afuera de mi casa",
    Icon: DoorClosed,
    color: "red",
    testId: EMERGENCY.scenarioDoor,
  },
  {
    id: "street",
    title: "Calle o trabajo",
    desc: "Me detuvieron afuera de casa",
    Icon: MapPin,
    color: "orange",
    testId: EMERGENCY.scenarioStreet,
  },
  {
    id: "detained",
    title: "Ya estoy detenido",
    desc: "Me piden firmar o ya me arrestaron",
    Icon: Lock,
    color: "zinc",
    testId: EMERGENCY.scenarioDetained,
  },
];

const COLOR_CLASSES = {
  red: "border-l-red-600 bg-red-50 text-red-700",
  orange: "border-l-amber-600 bg-amber-50 text-amber-700",
  zinc: "border-l-zinc-700 bg-zinc-100 text-zinc-700",
};

export default function Emergency() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-50 pb-28">
      <div className="max-w-md mx-auto w-full px-5 pt-6">
        <button
          data-testid={EMERGENCY.cancel}
          onClick={() => navigate("/dashboard")}
          className="flex items-center gap-2 text-sm font-semibold text-zinc-600 mb-6 hover:text-zinc-900"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver
        </button>

        <div className="mb-6">
          <p className="text-xs uppercase tracking-widest font-bold text-red-600 mb-2">
            Emergencia activa
          </p>
          <h1 className="text-3xl font-black tracking-tight text-zinc-900 leading-tight">
            Respira.
            <br />
            ¿Dónde estás ahora?
          </h1>
          <p className="text-base text-zinc-700 mt-3 leading-relaxed">
            Elige tu situación. Te guiaré paso a paso con voz.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {SCENARIOS.map((s) => {
            const { Icon } = s;
            return (
              <button
                key={s.id}
                data-testid={s.testId}
                onClick={() => navigate(`/scenario/${s.id}`)}
                className={`w-full bg-white border-2 border-zinc-200 border-l-8 ${COLOR_CLASSES[s.color].split(" ")[0]} hover:border-zinc-300 active:scale-[0.98] transition-all rounded-xl p-5 flex items-center gap-4 text-left`}
              >
                <div className={`w-14 h-14 rounded-2xl ${COLOR_CLASSES[s.color].split(" ").slice(1).join(" ")} flex items-center justify-center flex-shrink-0`}>
                  <Icon className="w-8 h-8" strokeWidth={2.5} />
                </div>
                <div className="flex-1">
                  <div className="text-xl font-bold text-zinc-900 leading-tight">{s.title}</div>
                  <div className="text-sm text-zinc-600 mt-1 leading-snug">{s.desc}</div>
                </div>
              </button>
            );
          })}
        </div>

        <div className="mt-8 bg-amber-50 border-2 border-amber-200 rounded-xl p-4">
          <p className="text-sm font-semibold text-amber-900 leading-relaxed">
            Recuerda: tienes derechos. No hables más de lo necesario y no firmes nada sin un abogado.
          </p>
        </div>
      </div>
      <DisclaimerBanner />
    </div>
  );
}
